export default "__VITE_ASSET__96006289__"